import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import LogoLoader from 'components/Loader/LogoLoader';
import Title from 'components/Title';
import { useFetchNotificationById } from 'hooks/notification/useFetchNotificationById';
import { formatYearMonthDayTime } from 'utils/format';

const NotificationDetail: React.FC<unknown> = () => {
  const { t } = useTranslation(['common']);

  const { id } = useParams();

  const { status, data } = useFetchNotificationById(id!);

  if (status === 'loading') return <LogoLoader />;

  return (
    <Box>
      <Title>{t('common:notificationDetails')}</Title>

      <Box
        maxWidth="700px"
        mx="auto"
        mt="10"
        sx={{
          '& > *': { px: '4', py: '3' },
          '& > *:nth-of-type(odd)': { background: 'primary.50' },
        }}
      >
        <Flex>
          <Text as="strong" flex="0 0 120px">
            {t('common:message')}
          </Text>
          <Text flex="1 1 auto">
            {Array.isArray(data?.payload?.message)
              ? data?.payload?.message?.map((message: any) => {
                  return (
                    <Flex flexDirection="column">
                      <Flex gridGap={2}>
                        <Text>{t('common:description')}:</Text> <Text>{message?.description}</Text>
                      </Flex>
                      <Flex gridGap={2}>
                        <Text>{t('common:resolution')}:</Text> <Text>{message?.resolution}</Text>
                      </Flex>
                    </Flex>
                  );
                })
              : data?.payload?.message}
          </Text>
        </Flex>
        <Flex>
          <Text as="strong" flex="0 0 120px">
            {t('common:status')}
          </Text>
          <Text flex="1 1 auto">{data?.payload?.is_read ? 'Read' : 'Unread'}</Text>
        </Flex>
        <Flex>
          <Text as="strong" flex="0 1 120px">
            {t('common:on')}
          </Text>
          <Text flex="1 1 auto">
            {data?.payload?.created_at ? formatYearMonthDayTime(`${data?.payload?.created_at}Z`) : ''}
          </Text>
        </Flex>
        <Flex>
          <Text as="strong" flex="0 1 120px">
            {t('common:from')}
          </Text>
          <Text flex="1 1 auto">{data?.payload?.entity}</Text>
        </Flex>
      </Box>
    </Box>
  );
};

export default NotificationDetail;
